export const LogisticsOrderDetailsEndpoint = {
  RETRIEVE_ORDER_DETAILS: '/api/admin/logistics/order',
};
